module.exports = __webpack_public_path__ + "img/copy.caa2c724.svg";